import React from "react";
import useUserPaymentTransactions from "../hooks/useUserPaymentTransactions";
import { useNavigate, useParams } from "react-router-dom";
import { formatINR } from "../utils/formatINR";

const UserPaymentTransactions = () => {
  const { userId } = useParams();
  const { transactions, isLoading, error, message, refetch } =
    useUserPaymentTransactions();
  const navigate = useNavigate();

  
  const unwrap = (field) => (field && field.Valid ? field.String : "-");

  const handleRowClick = (txn) => {
    if (txn.charging_session_id?.Valid && txn.charging_session_id.String) {
      navigate(`/charging-sessions/${txn.charging_session_id.String}`);
    }
  };

  return (
    <div className="p-4 space-y-6">
       <div className="bg-white shadow rounded-xl p-6 border border-gray-200 flex items-center justify-between">
        <h2 className="text-xl font-bold">
          Payment Transactions – User {userId}
        </h2>

        <button
          onClick={() => navigate(`/payment-transactions/${userId}/add`)}
          className="px-5 py-2 rounded-lg bg-orange-500 text-white font-semibold shadow hover:bg-orange-600 hover:shadow-lg transition-all"
        >
          + Add Missing Transaction
        </button>
      </div>

      {error && <p className="text-red-500">{error}</p>}
      {message && <p className="text-green-600">{message}</p>}

      {isLoading ? (
        <p>Loading...</p>
      ) : transactions.length === 0 ? (
        <p>No transactions found.</p>
      ) : (
        <table className="w-full border border-gray-300 text-sm">
          <thead className="bg-gray-100">
            <tr>
              <th className="border px-3 py-2">Txn ID</th>
              <th className="border px-3 py-2">Charging Session</th>
              <th className="border px-3 py-2">Payment Method</th>
              <th className="border px-3 py-2">Type</th>
              <th className="border px-3 py-2">Amount</th>
              <th className="border px-3 py-2">Final Cost</th>
              <th className="border px-3 py-2">Status</th>
              <th className="border px-3 py-2">Date</th>
              <th className="border px-3 py-2">Description</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((txn) => (
              <tr
                key={txn.id}
                className={`hover:bg-gray-50 ${
                  txn.charging_session_id?.Valid ? "cursor-pointer" : "cursor-default"
                }`}
                onClick={() => handleRowClick(txn)}
              >
                <td className="border px-3 py-2">{txn.id}</td>
                <td className="border px-3 py-2">
                  {unwrap(txn.charging_session_id)}
                </td>
                <td className="border px-3 py-2">
                  {txn.payment_method_type}
                </td>
                <td className="border px-3 py-2">{txn.transaction_type}</td>
                <td className="border px-3 py-2">{formatINR(txn.amount)}</td>
                <td className="border px-3 py-2">
                  {txn.final_cost !== null && txn.final_cost !== undefined
                    ? formatINR(txn.final_cost)
                    : "-"}
                </td>
                <td className="border px-3 py-2">{txn.status}</td>
                <td className="border px-3 py-2">
                  {new Date(txn.created_at).toLocaleString()}
                </td>
                <td className="border px-3 py-2">{unwrap(txn.description)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <div className="mt-4">
        <button
          onClick={refetch}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          Refresh
        </button>
      </div>
    </div>
  );
};

export default UserPaymentTransactions;
